import uiConfig from '@onereach/ui-config';
import config from '../env.json';

export default uiConfig(config, {}, {}, false);